module.exports = __webpack_public_path__ + "img/atlassian-community.225b01cf.png";